// @flow
import React, { useEffect, useRef, useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import "./therapists-list.scss";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "src/latest/src/components";
import PaginationController from "../../../latest/src/components/PaginationController";
import {
    clearModalContent,
    setModalContent,
} from "../../../redux/modules/modalEvent";
import {
    blockScheduleSlot,
    getScheduleSlotStatus,
} from "../../../redux/services/calenderServices";
import { fetchQuestionnaireMetaData } from "src/redux/actions/questionnaireActions";
import { Logger } from "src/services";
import { useIsMobile } from "src/latest/src/hooks";
import HelpMeFindATherapist from "src/components/base/HelpMeFindATherapist/HelpMeFindATherapist";
import { verifyAppointment } from "../../../api/user";
import BookAppointment from "./BookAppointmentModal/BookAppointment";
import TherapistListCard from "./TherapistListCard/TherapistListCard";
import TherapistMobileCard from "./TherapistMobileCard/TherapistMobileCard";
import InviteClientCA from "../InviteUser/InviteClientCA";
import MatchScoreModal from "./TherapistListCard/MatchScoreModal";
import DateNavigator from "src/latest/src/components/DateRangeSlider/DateRangeSlider";
import NoAvailableTherapist from "src/latest/src/components/NoAvailableTherapist/NoAvailableTherapist";
import filterIcon from '../../../assets/icons/new-icon-filter.svg';

type Props = {
    choices?: any,
    className?: string,
    list: Array<Object>,
    dateRequested: Array<string>,
    handleViewTherapistProfile: Function,
    handleMatchWithClient: Function,
    loadMoreResult: Function,
    setOffset: Function,
    offset: number,
    selectedUserData: Array<Object>,
    sliderDateChange: Function,
    isFloating: boolean,
    isFetching: boolean,
    onPageChange: Function,
    totalPages: number,
    currentPage: number,
    selectedUserId: String,
    updateSlot: Function,
    handleOnclick: Function,
    selectedFilters: Object,
    handleLaterSlot:Function,
};

export default function TherapistsList({
    choices,
    className = "",
    list,
    dateRequested,
    loadMoreResult,
    offset,
    setOffset,
    sliderDateChange,
    isFloating,
    isFetching,
    onPageChange,
    totalPages,
    currentPage,
    selectedUserId,
    updateSlot,
    handleOnclick,
    selectedFilters,
    handleLaterSlot,
}: Props): React$Element<any> {
    const location = useLocation();
    const navigate = useNavigate();
    const loadMoreAuditLogTrigger = useRef();
    const [offsetEle, setoffsetEle] = useState(offset);
    const [cardExpand, setCardExpand] = useState(null);
    const [moreVisible, setmoreVisible] = useState([]);
    const [expandAvailability, setExpandAvailability] = useState(null);
    const dispatch = useDispatch();
    const loggedInUser = useSelector(
        (state) => state?.authentication?.loggedInUser
    );
    const [statusLoading, setStatusLoading] = useState(false);
    const [statusLoadingElement, setStatusLoadingElement] = useState("");
    const [id, setId] = useState("");
    const isFromMobile = useIsMobile();
    const showMatchScoreBtn = useSelector((state) => state?.questionnaireData?.initialMetadata?.show_match_score_btn);
    const pageUniqueKey = location.state?.currentLocation?.state?.pageKey;
    const noAvailableTherapistForCA = 'Oops, we aren’t able to find any available providers who match your filter criteria.';
    const history = useNavigate();
    const serviceType = useSelector(
        (state) =>
            state?.questionnaireData?.currentConfig?.combinedFilters
                ?.schedule_request?.service_type
    );

    const { blackoutHours, blackoutDays, practiceTimeZone } = useSelector(
        (state: any) => state?.configuration
    );

    const onIntersect = async (entries) => {
        const firstElement = entries[0];

        if (firstElement.isIntersecting) {
            loadMoreResults();
        }
    };

    const loadMoreResults = () => {
        setoffsetEle(offset + 1);
    };

    const isClinicianAvailabilityPage = window.location.pathname.includes("/clinician-availability");

    useEffect(() => {
        setOffset(offsetEle);
        loadMoreResult(offsetEle);
    }, [offsetEle]);

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "10px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(onIntersect, option);

        if (observer && loadMoreAuditLogTrigger.current) {
            observer.observe(loadMoreAuditLogTrigger.current);
        }

        return () => {
            dispatch(clearModalContent());

            if (observer) {
                observer.disconnect();
            }
        };
    }, [list]);

    const handleFlipCard = (i) => {
        if (cardExpand === i) {
            setCardExpand(null);
        } else {
            setCardExpand(i);
            setExpandAvailability(null);
        }
    };

    const handleAvailability = (i) => {
        if (expandAvailability === i) {
            setExpandAvailability(null);
        } else {
            setExpandAvailability(i);
        }
    };

    useEffect(() => {
        getMoreVisibility();
        setExpandAvailability(null);
        setCardExpand(null);
    }, [list]);

    useEffect(() => {
        setId(loggedInUser?.id);
    }, [loggedInUser]);

    const getMoreVisibility = () => {
        const arr = [];
        const slotToVisible = isFromMobile === true ? 3 : 4;

        // changed .map() to .forEach() below to remove the eslint warnings.
        list.forEach((item) => {

            if (item.therapist_id && item.grouped_slot_data) {
                Object.values(item.grouped_slot_data).forEach((date) => {
                    if (date.length > slotToVisible && !arr.includes(item.therapist_id)) {
                        arr.push(item.therapist_id);
                    }
                });
            }
        });

        setmoreVisible(arr);
    };

    const profileRedirection = (therapistId) => {
        window.open(
            process.env.PUBLIC_URL +
            `/profile/${therapistId}#profile`,
            "_blank"
        );
    };

    const bookAppointmentSlot = async (slot, item) => {
        if (
            loggedInUser !== {} &&
            loggedInUser?.user_type?.includes("THERAPIST") &&
            !(
                loggedInUser?.user_type?.includes("SCHEDULER") ||
                loggedInUser?.user_type?.includes("PRACTICE_ADMIN")
            )
        ) {
            return;
        }

        setStatusLoading(true);
        setStatusLoadingElement(item.id);

        const availableSlot = await getScheduleSlotStatus(slot.slot.hash); // { available_status: true }; //
    
        setStatusLoading(false);
        setStatusLoadingElement("");

        if (availableSlot.available_status === false) {
            openOpeningNotAvailableModal(item);
        }

        if (availableSlot.available_status === true) {
            openBookAppointmentModal(slot, item, availableSlot);
        }
    };

    const openOpeningNotAvailableModal = (item) => {
        dispatch(
            setModalContent({
                modalContent: (
                    <div>
                        <Typography
                            variant="size-22"
                            className="mb-5 mt-5 slotsnotAvailable-text"
                            color="color-31"
                        >
                            The appointment you selected is no longer<br />
                            available. Please select a different time slot.
                        </Typography>
                    </div>
                ),
                isWithCancelButton: false,
                size: "lg",
                title: "Oops!",
                onConfirmButtonClick: () => handleTakeMeBack(item),
                className: "check-slot-available",
                confirmButtonLabel: "Pick Another Time",
            })
        );
    };

    const openBookAppointmentModal = (slot, item, availableSlot) => {
        dispatch(
            setModalContent({
                modalContent: (
                    <BookAppointment
                        item={item}
                        slot={slot}
                        handleConfirmMatching={handleConfirmMatching}
                        clientId={selectedUserId}
                        avialbleSlotDetails={availableSlot}
                        selectedFilters={selectedFilters}
                        isClinicianAvailabilityPage={isClinicianAvailabilityPage}
                    />
                ),
                isWithCancelButton: false,
                size: "lg",
                title: "Review Appointment Details",
                className: "book-appointments-match-modal",
            })
        );
    };

    const handleCloseModal = (isToBeRedirect:Boolean) => {
        dispatch(clearModalContent());

        if(isToBeRedirect){
            dispatch(fetchQuestionnaireMetaData(true, pageUniqueKey));
            navigate("/therapy/initquestions",{replace:true});
        }
    };

    // eslint-disable-next-line no-unused-vars
    const handleConfirmMatching = async (
        item,
        slot,
        clientId,
        intakeSelected,
        availableSlotDetails
    ) => {
        const appointmenType =
            intakeSelected === ""
                ? slot.slot.meeting_pref.includes("Online")
                    ? "INTAKE_ONLINE"
                    : "INTAKE_IN_PERSON"
                : intakeSelected;

        let ID;

        if (localStorage.getItem("isFromBookingPage")) {
            ID = id;
        } else {
            ID = clientId;
        }

        try {
            if (!serviceType) {
                console.error("ServiceType not selected");

                return;
            }

            if((loggedInUser?.user_type?.includes("SCHEDULER") ||
                loggedInUser?.user_type?.includes("PRACTICE_ADMIN")) &&  isClinicianAvailabilityPage){
                     dispatch(clearModalContent());
                    dispatch(
                        setModalContent({
                            modalContent: (
                                <InviteClientCA
                                    type={"client"}
                                    slotDetails={{
                                        appointment_type: appointmenType,
                                        client_id: ID,
                                        schedule_id:
                                            availableSlotDetails.schedule_id,
                                        office_address:
                                            item?.other_data
                                                ?.therapist_practice_address_info,
                                        service_type: serviceType,
                                        slot_hash:slot.slot.hash,
                                      slot_reason_type : slot.slot.slot_reason_type
                                    }}
                                    setCloseModalAndRedirect={handleCloseModal}
                                />
                            ),
                            title:"Invite a new client",
                            className:"invite-client-modal-ca"
                        })
                    );
                }else{
                     const blockSlot = await blockScheduleSlot(
                {
                    appointment_type: appointmenType,
                    client_id: ID,
                    schedule_id: availableSlotDetails.schedule_id,
                    office_address:
                        item?.other_data?.therapist_practice_address_info,
                    service_type: serviceType,
                },
                slot.slot.hash
            );

            if (blockSlot.http_code === 200) {
                await verifyAppointment(ID);
                dispatch(clearModalContent());

                if (localStorage.getItem("isFromBookingPage")) {
                    localStorage.removeItem("isFromBookingPage");
                    // call the status update api
                    history("/meeting-info");
                }else{
                    handleHelpMeFindATherapist(false);

                }
            }
                }
           
        } catch (e) {
            Logger.error("Book appointment", e);
        }
    };

    const handleTakeMeBack = () => {
        updateSlot();
        dispatch(clearModalContent());
    };

    const handleHelpMeFindATherapist = (status: Boolean, concernText: string) => {
        let helpMeFindMatchconfig;

        if (choices?.length) {
            helpMeFindMatchconfig = Object.assign([], choices);
            helpMeFindMatchconfig[0].selected = status;
            helpMeFindMatchconfig[0].requested_match_help_free_text = concernText;
        } else {
            helpMeFindMatchconfig = {
                config_type: "REQUESTED_MATCH_HELP_TODO",
                metadata: {
                    requested_match_help_free_text: concernText
                }
            };
        }

        handleOnclick(helpMeFindMatchconfig);
    };

    return (
        <div className={`therapists-listCA ${className}`}>
            {/* <div className='therapists-list__count'>
                <Typography variant='size-20'>
                    {list.length} match{list.length === 1 ? '' : 'es'}
                </Typography>
            </div> */}
            {showMatchScoreBtn && (
                <div
                    className={`${isFromMobile
                            ? "app-bottom-fixed-button"
                            : "d-none"
                        }`}
                >
                    <MatchScoreModal />
                </div>
            )}
            {dateRequested?.length && (
                <div
                    className={`therapists-listCA__date-slider-container ${isFloating === true ? "floating-date-slider" : ""
                        }`}
                >
                    <DateNavigator
                        handleDateChange={sliderDateChange}
                        isFromMobile={isFromMobile}
                        initDate={dateRequested[0]}
                        blackoutDays={blackoutDays}
                        blackoutHours={blackoutHours}
                        practiceTimeZone={practiceTimeZone}
                        isFromQuestionnaire={!isClinicianAvailabilityPage}
                    />
                </div>
            )}
            {!isFetching ? (
                <div
                    className={`therapists-listCA__wrapper ${isFloating === true ? "custom-margin" : ""
                        } ${isFromMobile ? "pt-3" : ""}`}
                >
                    {list && list?.length === 0 && (       
                            <NoAvailableTherapist noAvailIcon={filterIcon} noAvailText={noAvailableTherapistForCA}/>
                    )}
                    {list.map((item, i) => {
                        return (
                            <div key={item.id}>
                                {item.therapist_id ? (
                                    !isFromMobile ? (
                                        <TherapistListCard
                                            isClinicianAvailabilityPage={isClinicianAvailabilityPage}
                                            practiceTimeZone={practiceTimeZone}
                                            therapistInfo={item}
                                            index={i}
                                            profileRedirection={
                                                profileRedirection
                                            }
                                            expandAvailability={
                                                expandAvailability
                                            }
                                            cardExpand={cardExpand}
                                            handleAvailability={
                                                handleAvailability
                                            }
                                            moreVisible={moreVisible}
                                            handleFlipCard={handleFlipCard}
                                            statusLoading={statusLoading}
                                            bookAppointmentSlot={
                                                bookAppointmentSlot
                                            }
                                            statusLoadingElement={
                                                statusLoadingElement
                                            }
                                            handleLaterSlot={handleLaterSlot}
                                        />
                                    ) : (
                                        <div>
                                            <TherapistMobileCard
                                                practiceTimeZone={practiceTimeZone}
                                                therapistInfo={item}
                                                bookAppointmentSlot={
                                                    bookAppointmentSlot
                                                }
                                                statusLoading={statusLoading}
                                                statusLoadingElement={statusLoadingElement}
                                                index={i}
                                                profileRedirection={profileRedirection}
                                                expandAvailability={expandAvailability}
                                                moreVisible={moreVisible}
                                                cardExpand={cardExpand}
                                                handleAvailability={
                                                    handleAvailability
                                                }
                                                handleLaterSlot={handleLaterSlot}
                                            />
                                        </div>
                                    )
                                ) : (
                                    <div className="help-me-find-a-therapist-container mb-lg-5 mb-md-0 mb-sm-0">
                                        <HelpMeFindATherapist
                                            title={item?.other_data?.header}
                                            subtitle={
                                                item?.other_data?.sub_header
                                            }
                                            buttonLabel={
                                                item?.other_data?.button_label
                                            }
                                            buttonAction={(
                                                concernText: string
                                            ) => {
                                                handleHelpMeFindATherapist(
                                                    true,
                                                    concernText
                                                );
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div
                    className="col-8 flex-shrink-0 mb-5"
                    style={{ width: `${isFromMobile ? "100px" : "auto"}`, margin: "auto" }}
                >
                    <Spinner
                        animation="border"
                        role="status"
                        variant="dark"
                        className="mx-auto matching-spinner d-flex"
                    />
                </div>
            )}
            <div className="last_div" ref={loadMoreAuditLogTrigger} />
            {totalPages > 1 && (
                <div className={`${isFromMobile
                    ? "mt-4"
                    : ""
                    } d-flex justify-content-center`}>
                    <PaginationController
                        activePage={currentPage - 1}
                        totalNoOfPages={totalPages}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </div>
    );
}
